var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"spinner",attrs:{"width":`${_vm.size}px`,"height":`${_vm.size}px`,"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"45","stroke":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }